import script from "./SyncModuleAccess.vue?vue&type=script&setup=true&lang=ts"
export * from "./SyncModuleAccess.vue?vue&type=script&setup=true&lang=ts"

import "./SyncModuleAccess.vue?vue&type=style&index=0&id=188ac560&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-188ac560"]])

export default __exports__